import { DatePicker, DatePickerProps } from 'antd';

const DatePickerForm = (props: DatePickerProps) => {
  return <DatePicker style={{ width: '100%' }} size="large" {...props} />;
};

export default DatePickerForm;
